import { render, staticRenderFns } from "./MealCompare.vue?vue&type=template&id=7d053728&scoped=true&"
import script from "./MealCompare.vue?vue&type=script&lang=js&"
export * from "./MealCompare.vue?vue&type=script&lang=js&"
import style0 from "./MealCompare.vue?vue&type=style&index=0&id=7d053728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d053728",
  null
  
)

export default component.exports